function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@leverege/ui-elements';
import useResponsiveBreakpoints from "./UseResponsiveBreakpoints.js";
const components = {
  small: TwoStepModalMobile,
  big: TwoStepModalDesktop
};
function TwoStepModal(props) {
  return useResponsiveBreakpoints(components, props);
}
export default connect(state => ({
  profile: state.auth.profile
}))(TwoStepModal);
function TwoStepModalDesktop(props) {
  const {
    show,
    onClose,
    flow: Flow
  } = props;
  return /*#__PURE__*/React.createElement(Dialog, {
    variant: "enableTwoStep|twoStep",
    show: show,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Flow, _extends({
    headerVariant: "twoStepHeader",
    contentVariant: "twoStepContent",
    footerVariant: "twoStepFooter"
  }, props)));
}
function TwoStepModalMobile(props) {
  const {
    show,
    onClose,
    flow: Flow
  } = props;
  return /*#__PURE__*/React.createElement(Dialog, {
    position: "full",
    variant: "twoStepMobile|twoStep",
    show: show,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Flow, _extends({
    headerVariant: "twoStepMobileHeader|twoStepHeader",
    contentVariant: "twoStepMobileContent|twoStepContent",
    footerVariant: "twoStepMobileFooter|twoStepFooter"
  }, props, {
    mobile: true
  })));
}